var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 81 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2369,321.826)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09459,0,0,1.09459,3511.76,-481.637)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37,
    style: {
      fill: "white"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.219364,0,0,0.219364,-1271.78,276.359)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.3364,0,0,50.0269,33177.6,-29606.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.981875,-4.19321e-05,0.000117598,0.41139,-5976.21,-1926.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4402,6096C4404.21,6096 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398,6102.21 4398,6100C4398,6097.79 4399.79,6096 4402,6096Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4402,6096C4404.21,6096 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398,6102.21 4398,6100C4398,6097.79 4399.79,6096 4402,6096Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.15386,6.90909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4400.75,6092.6C4401.58,6090.56 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398.31,6102.19 4398,6100C4397.65,6097.52 4399.86,6094.82 4400.75,6092.6Z",
    style: {
      fill: "rgb(216,132,66)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,6.77686e-05,0.237074,-3356.63,-867.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.9 4401.67,6131.93 4405,6130L4404,6125L4396,6125Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.9 4401.67,6131.93 4405,6130L4404,6125L4396,6125Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.70294,0,1821.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6101.05C4390,6100.47 4390.52,6100 4391.17,6100L4408.83,6100C4409.48,6100 4410,6100.47 4410,6101.05L4410,6119.74C4410,6119.91 4409.92,6120.07 4409.79,6120.18C4408.88,6120.96 4405.16,6124.15 4402.55,6126.38C4401.07,6127.64 4398.74,6127.63 4397.28,6126.36C4394.72,6124.12 4391.1,6120.96 4390.2,6120.18C4390.07,6120.06 4390,6119.91 4390,6119.74L4390,6101.05Z",
    style: {
      fillOpacity: 0.11
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3357.01,-331.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4409.31,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z",
    style: {
      fill: "rgb(179,97,42)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4409.31,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,-1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.09C4412,6109.8 4411.94,6109.52 4411.84,6109.32C4411.74,6109.11 4411.6,6109 4411.45,6109C4410.86,6109 4410,6109 4410,6109L4410,6113C4410,6113 4410.44,6113.02 4410.9,6113.05C4411.19,6113.06 4411.47,6112.84 4411.68,6112.44C4411.88,6112.04 4412,6111.48 4412,6110.91C4412,6110.62 4412,6110.35 4412,6110.09Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3355.95,-331.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390.5,6113 4390.5,6113L4390,6109Z",
    style: {
      fill: "rgb(222,137,81)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390.5,6113 4390.5,6113L4390,6109Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4388.55,6109C4388.4,6109 4388.26,6109.11 4388.16,6109.32C4388.06,6109.52 4388,6109.8 4388,6110.09L4388,6110.86C4388,6112.04 4388.48,6113 4389.07,6113L4390,6113L4390,6109Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.362722,-1.54904e-05,3.37518e-05,0.118073,-3249.45,-138.475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390.73,6108.77C4390.73,6103.93 4393.93,6100 4398.77,6100C4399.59,6100 4400.41,6100 4401.23,6100C4406.07,6100 4409.27,6103.93 4409.27,6108.77C4409.27,6109.76 4409.01,6112.55 4408.71,6115.44C4408.38,6120.38 4405.6,6124.6 4401.65,6126.19C4401.65,6126.21 4401.65,6126.21 4401.65,6126.21C4400.58,6126.64 4399.42,6126.64 4398.35,6126.21C4398.35,6126.21 4398.35,6126.21 4398.35,6126.21C4394.39,6124.62 4391.61,6120.39 4391.27,6115.44C4390.99,6112.54 4390.73,6109.76 4390.73,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.199219,-8.50785e-06,2.31378e-05,0.0809427,-2530.06,88.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4399.73,6112C4399.32,6112 4398,6115.49 4398,6115.67C4398,6115.86 4398,6116.08 4398,6116.27C4398,6116.68 4398.32,6117 4398.73,6117C4399.45,6117 4400.55,6117 4401.27,6117C4401.68,6117 4402,6116.68 4402,6116.27L4402,6115.67C4402,6115.49 4400.68,6112 4400.27,6112C4400.1,6112 4399.9,6112 4399.73,6112Z",
    style: {
      fill: "rgb(255,158,94)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.365234,-1.55977e-05,3.35233e-05,0.117274,-3260.6,-133.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119C4404,6120.66 4402.66,6122 4401,6122C4400.35,6122 4399.65,6122 4399,6122C4397.34,6122 4396,6120.66 4396,6119C4396,6119 4396,6119 4396,6119Z",
    style: {
      fill: "rgb(46,18,0)",
      fillOpacity: 0.7
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119C4404,6120.66 4402.66,6122 4401,6122C4400.35,6122 4399.65,6122 4399,6122C4397.34,6122 4396,6120.66 4396,6119C4396,6119 4396,6119 4396,6119Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119.87C4404,6121.05 4403.21,6122 4402.23,6122C4400.9,6122 4399.1,6122 4397.77,6122C4396.79,6122 4396,6121.05 4396,6119.87C4396,6119.38 4396,6119 4396,6119Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.22465e-16,-1.22465e-16,-1,8800,12243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119C4404,6119 4404,6119.38 4404,6119.87C4404,6121.05 4403.21,6122 4402.23,6122C4400.9,6122 4399.1,6122 4397.77,6122C4396.79,6122 4396,6121.05 4396,6119.87C4396,6119.38 4396,6119 4396,6119Z",
    style: {
      fill: "rgb(164,43,43)",
      fillOpacity: 0.94
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3356.31,-331.045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)",
      fillOpacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3352.97,-331.045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)",
      fillOpacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3356.31,-331.297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4393,6109.5C4393,6109.37 4393.05,6109.24 4393.15,6109.15C4393.24,6109.05 4393.37,6109 4393.5,6109C4394.27,6109 4395.73,6109 4396.5,6109C4396.63,6109 4396.76,6109.05 4396.85,6109.15C4396.95,6109.24 4397,6109.37 4397,6109.5C4397,6109.63 4396.95,6109.76 4396.85,6109.85C4396.76,6109.95 4396.63,6110 4396.5,6110C4395.73,6110 4394.27,6110 4393.5,6110C4393.37,6110 4393.24,6109.95 4393.15,6109.85C4393.05,6109.76 4393,6109.63 4393,6109.5Z",
    style: {
      fill: "rgb(121,71,32)",
      fillOpacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387034,-1.65287e-05,4.27629e-05,0.149596,-3356.84,-331.297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4403,6109.5C4403,6109.37 4403.05,6109.24 4403.15,6109.15C4403.24,6109.05 4403.37,6109 4403.5,6109C4404.27,6109 4405.73,6109 4406.5,6109C4406.63,6109 4406.76,6109.05 4406.85,6109.15C4406.95,6109.24 4407,6109.37 4407,6109.5C4407,6109.63 4406.95,6109.76 4406.85,6109.85C4406.76,6109.95 4406.63,6110 4406.5,6110C4405.73,6110 4404.27,6110 4403.5,6110C4403.37,6110 4403.24,6109.95 4403.15,6109.85C4403.05,6109.76 4403,6109.63 4403,6109.5Z",
    style: {
      fill: "rgb(121,71,32)",
      fillOpacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.265625,-1.13438e-05,2.93485e-05,0.102669,-1334.62,553.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1212.31,285C-1205.27,283.17 -1197.27,280.57 -1194.5,275.5C-1192.34,279.652 -1191.65,282.673 -1187,285.056L-1186,281L-1192,273L-1201,272L-1208,274L-1212,278L-1212.31,285Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1090.56,-160L1090.56,-274.631C1090.56,-299.728 1107.87,-321.508 1132.32,-327.167C1152.88,-331.925 1173.31,-336.653 1173.31,-336.653C1179.81,-296.377 1227.94,-295.205 1245.21,-336.653C1245.21,-336.653 1271.06,-332.783 1287.96,-328.15C1319.18,-319.593 1324.03,-292.985 1323.5,-274.335C1321.44,-202.046 1323.5,-160 1323.5,-160L1090.56,-160Z",
    style: {
      fill: "rgb(14,164,233)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueChat);
export default __webpack_public_path__ + "static/media/blue_chat.36b476bdcf83ef3c05792992a43d4f87.svg";
export { ForwardRef as ReactComponent };